import React, { useEffect, useState, useRef } from "react";
import {
  Container,
  ContentContainer,
  Typo,
  Flex,
  Line,
  Grid,
  Button,
  Input,
  Div,
  LoadingIcon,
} from "../../components";
import Context from "../../Context";
import { useParams } from "react-router-dom";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import themes from "../../themes";
import { Collapse, Modal } from "reactstrap";
import { getThaiDateFormat } from "../../constants";
import { resizeImage, monthTh } from "../../util";
import styled from "styled-components";

export const CouponPayment = () => {
  const { callApi, configs, profileState, go, toast } = Context();
  const uploadRef = useRef(null);
  const { couponId } = useParams();
  const [product, setProduct] = useState();
  const [isShowPayment, setShowPayment] = useState(false);
  const [isShowForm, setShowForm] = useState(false);
  const [previewImage, setPreviewImage] = useState();
  const [slip, setSlip] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    (async () => {
      const coupon = await callApi("coupons-getCoupon", {
        id: couponId,
      });

      if (coupon.data.status !== "active") {
        toast("คูปองนี้ปิดใช้งานชั่วคราว");
        go("/coupon");
        return;
      }
      if (coupon.data.price === 0 && !profileState.lineId) {
        toast("ท่านไม่ได้เชื่อมระบบไลน์หงษ์ทอง โปรดติดต่อแอดมินค่ะ");
        go("/coupon");
      }
      if (
        coupon.data.price === 0 &&
        profileState?.redeemedCode?.includes(coupon.data.shortId)
      ) {
        toast("1 คน 1 สิทธิ์ สิทธิ์ของท่านถูกใช้ไปแล้ว");
        go("/coupon");
      }

      setProduct(coupon.data);
    })();
  }, [couponId]);

  const handleSubmit = async () => {
    if (!slip) {
      return toast("กรุณาอัปโหลดสลิป");
    }
    await callApi("coupons-createTransaction", {
      slip,
      id: couponId,
    }).then((result) => {
      if (result.status) {
        go("/status/coupon_paid");
      } else {
        go("/status/canceled");
      }
    });
  };

  const handleRedeemPointSubmit = async () => {
    await callApi("coupons-createTransaction", {
      id: couponId,
    }).then((result) => {
      if (result.status) {
        go(`/status/coupon_approved/${result.orderId}`);
      } else {
      }
    });
  };

  return (
    <Container margin="0 0 75px 0">
      <CouponModal
        showModal={showModal}
        setShowModal={setShowModal}
        handleRedeemPointSubmit={handleRedeemPointSubmit}
        isFailed={profileState?.buyPoint < product?.price}
        price={product?.price}
      />

      <Collapse isOpen={!isShowPayment}>
        <CouponDetail
          product={product}
          setShowPayment={setShowPayment}
          isShowPayment={isShowPayment}
          setShowModal={setShowModal}
          showModal={showModal}
        />
      </Collapse>
      <Collapse isOpen={isShowPayment}>
        <PaymentContainer
          product={product}
          couponId={couponId}
          isShowForm={isShowForm}
          setShowForm={setShowForm}
          previewImage={previewImage}
          setPreviewImage={setPreviewImage}
          setSlip={setSlip}
          slip={slip}
          uploadRef={uploadRef}
          handleSubmit={handleSubmit}
          go={go}
          handleRedeemPointSubmit={handleRedeemPointSubmit}
        />
      </Collapse>
    </Container>
  );
};

const CouponDetail = ({
  product,
  setShowPayment,
  isShowPayment,
  setShowModal,
  showModal,
}) => {
  return (
    <CouponDetailContainer>
      {/* <ImageContainer imageUrl={product.image || "/images/bg_01.jpeg"} /> */}
      {product?.image ? (
        <img src={product?.image} alt="coupon" />
      ) : (
        <ImageContainer>
          <Typo.H4 color="green">{product?.name || "-"}</Typo.H4>
        </ImageContainer>
      )}
      <ContentContainer minHeight="0" padding="29px 35px">
        <Flex direction="column" gap="35px">
          <Typo.H4 color="textBlack">{product?.name || "-"}</Typo.H4>

          {product?.isPointRedeem ? (
            <Typo.H5 color="navy">
              ใช้คะแนนสะสม {product?.price?.toLocaleString()} คะแนน
            </Typo.H5>
          ) : (
            <Typo.H5 color="navy">
              ราคา {product?.price?.toLocaleString()} บาท
            </Typo.H5>
          )}
          <Flex direction="column">
            {(product?.type === "discount" || product?.type === "voucher") && (
              <>
                <Typo.H6 color="textBlack">
                  เงื่อนไขและข้อกำหนดในการใช้คูปอง
                </Typo.H6>
                <Typo.Body1 margin="10px 0" color="textBlack" weight="light">
                  1. สามารถใช้คูปองได้จนวินาทีสุดท้ายก่อนปิดระบบการขายในงวดนั้นๆ
                </Typo.Body1>
                <Typo.Body1
                  margin="0 0 10px 0"
                  color="textBlack"
                  weight="light"
                >
                  2. คูปองนี้สามารถใช้ได้เพียง 1 ครั้งเท่านั้น
                </Typo.Body1>
                <Typo.Body1
                  margin="0 0 10px 0"
                  color="textBlack"
                  weight="light"
                >
                  3. เมื่อสั่งซื้อคูปองสำเร็จเเล้ว
                  ลูกค้าต้องเลือกสลากตามจำนวนที่ระบุในคูปอง หรือมากกว่าเท่านั้น
                </Typo.Body1>
                <Typo.Body1
                  margin="0 0 10px 0"
                  color="textBlack"
                  weight="light"
                >
                  4. หากเลือกสลากไม่ครบตามจำนวนที่ระบุในคูปองไม่สามารถคืนสิทธิ์
                  หรือคืนเงินได้
                </Typo.Body1>
                <Typo.Body1
                  margin="0 0 10px 0"
                  color="textBlack"
                  weight="light"
                >
                  5. ไม่สามารถเปลี่ยนเป็นเงินสดได้
                </Typo.Body1>
              </>
            )}
            {product?.type === "reserve" && (
              <>
                <Typo.H6 color="textBlack" margin="25px 0 0 0">
                  เงื่อนไขและข้อกำหนดในการใช้คูปองสำหรับสิทธิ์การจองเลขท้าย
                </Typo.H6>

                <Typo.Body1 margin="10px 0" color="textBlack" weight="light">
                  1. หากมีสลากเข้ามาทางหงษ์ทอง
                  จะนำสลากเข้าระบบลูกค้าทันทีโดนที่ไม่แจ้งเวลาให้ทราบล่วงหน้า
                  ลูกค้าจะได้รับแจ้งเตือนให้ชำระเงินทันทีหลังสลากเข้าระบบ
                </Typo.Body1>
                <Typo.Body1
                  margin="0 0 10px 0"
                  color="textBlack"
                  weight="light"
                >
                  2. สามารถจองสลากได้สูงสุด {product.limitPerUsed} ใบ/ครั้ง
                </Typo.Body1>
                <Typo.Body1
                  margin="0 0 10px 0"
                  color="textBlack"
                  weight="light"
                >
                  3. ลูกค้าที่สั่งจองสลากเข้ามาต้องชำระเงินภายใน 2
                  ชม.หลังจากระบบเอาสลากเข้ากระเป๋า
                </Typo.Body1>
                <Typo.Body1
                  margin="0 0 10px 0"
                  color="textBlack"
                  weight="light"
                >
                  4. ลูกค้าใช้สิทธิ์จองเลขได้ถึงวันสลากออก 1 วัน
                </Typo.Body1>
                <Typo.Body1
                  margin="0 0 10px 0"
                  color="textBlack"
                  weight="light"
                >
                  5. ซื้อคูปองจองเลข
                  ลูกค้าเชื่อมต่อการแจ้งเตือนผ่านไลน์ก่อนสั่งซื้อเท่านั้น
                </Typo.Body1>
              </>
            )}
            {product?.type === "notify" && (
              <>
                <Typo.H6 color="textBlack" margin="25px 0 0 0">
                  เงื่อนไขและข้อกำหนดในการใช้คูปองสำหรับสิทธิ์การจองเลขท้าย
                </Typo.H6>

                <Typo.Body1 margin="10px 0" color="textBlack" weight="light">
                  1. สามารถใช้คูปองได้จนวินาทีสุดท้ายก่อนปิดระบบการขายในงวดนั้นๆ
                </Typo.Body1>
                <Typo.Body1
                  margin="0 0 10px 0"
                  color="textBlack"
                  weight="light"
                >
                  2.ไม่สามารถคืนสิทธิ์ หรือคืนเงินได้
                </Typo.Body1>
                <Typo.Body1
                  margin="0 0 10px 0"
                  color="textBlack"
                  weight="light"
                >
                  3. ไม่สามารถเปลี่ยนเป็นเงินสดได้
                </Typo.Body1>
                <Typo.Body1
                  margin="0 0 10px 0"
                  color="textBlack"
                  weight="light"
                >
                  4. เพิ่มการแจ้งเตือนได้ทีละ 1 ครั้ง
                </Typo.Body1>
                <Typo.Body1
                  margin="0 0 10px 0"
                  color="textBlack"
                  weight="light"
                >
                  5. แจ้งเตือนผ่านไลน์เท่านั้น
                </Typo.Body1>
              </>
            )}
            <Typo.Body2 color="navy" textAlign="center" margin="25px 0">
              หงษ์ทองขอสงวนสิทธิ์ไม่คืนเงินทุกกรณีที่มีการยกเลิกคำสั่งซื้อคูปองร่วมถึงคูปองที่ไม่มีการใช้ตามจำนวนและเวลาที่กำหนด
            </Typo.Body2>
          </Flex>

          <Line border={`5px dashed ${themes.colors.gray2}`} margin="0" />

          <Button
            margin="24px 0 0 0"
            height="55px"
            width="100%"
            size="20px"
            hoverColor="navy"
            weight={700}
            background="gradient2"
            hoverBg="transparent"
            hoverBorder="navy"
            gap="10px"
            onClick={() =>
              product.isPointRedeem
                ? setShowModal(!showModal)
                : setShowPayment(!isShowPayment)
            }
          >
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_58_480)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.25484 0.0578396C7.43494 0.29219 6.80214 0.93239 6.58989 1.74224C6.51379 2.03239 6.51059 2.11534 6.53564 3.13474C6.55029 3.73094 6.55369 4.21874 6.54309 4.21874C6.53254 4.21874 6.14024 3.98104 5.67129 3.69049C4.32979 2.85939 3.66174 2.74899 2.73494 3.20524C1.20704 3.95744 0.984792 6.17089 2.33714 7.16644L2.57374 7.34064L2.36649 7.45859C2.25249 7.52349 1.82584 7.76589 1.41839 7.99724C0.225492 8.67464 0.230292 8.63619 1.14604 10.1793C1.94419 11.5243 1.98199 11.5653 2.37264 11.5129C2.58234 11.4848 14.8511 4.39904 14.9641 4.24084C15.017 4.16674 15.0508 4.04929 15.0597 3.90879L15.0735 3.69139L14.4621 2.63734C13.7401 1.39254 13.7416 1.39479 13.5701 1.31339C13.2728 1.17234 13.2073 1.19714 11.9555 1.92514L11.2439 2.33894L11.2228 2.19484C11.1236 1.51629 10.9427 1.09079 10.6008 0.73214C10.024 0.12709 9.02114 -0.16121 8.25484 0.0578396ZM9.31454 1.29019C10.079 1.61834 10.2562 2.68304 9.63559 3.21884C9.54119 3.30034 9.08599 3.58499 8.62409 3.85134L7.78424 4.33564L7.75134 3.25179C7.71934 2.19834 7.72079 2.16174 7.80189 1.94629C8.03069 1.33849 8.72519 1.03724 9.31454 1.29019ZM17.2038 3.62879C16.7004 3.96069 16.9281 4.72604 17.5303 4.72604C17.9031 4.72604 18.1157 4.51344 18.1157 4.14064C18.1157 3.76779 17.9031 3.55519 17.5303 3.55519C17.3854 3.55519 17.2791 3.57914 17.2038 3.62879ZM4.25414 4.26809C4.46859 4.37174 6.00679 5.32329 6.00554 5.35154C6.00504 5.36229 5.58874 5.60839 5.08039 5.89844L4.15614 6.42579L3.85359 6.43954C2.59449 6.49694 2.18819 4.81159 3.33114 4.27254C3.59849 4.14644 3.99849 4.14454 4.25414 4.26809ZM18.4148 5.97254C18.1984 6.11524 18.1559 6.22954 18.1556 6.66989L18.1553 7.07029L17.7549 7.07054C17.1824 7.07094 16.984 7.22169 16.984 7.65624C16.984 8.09079 17.1824 8.24154 17.7549 8.24194L18.1553 8.24219L18.1556 8.64259C18.156 9.21509 18.3067 9.41354 18.7413 9.41354C19.1758 9.41354 19.3266 9.21509 19.3269 8.64259L19.3272 8.24219L19.7276 8.24194C20.3001 8.24154 20.4986 8.09079 20.4986 7.65624C20.4986 7.22169 20.3001 7.07094 19.7276 7.07054L19.3272 7.07029L19.3269 6.66989C19.3266 6.09739 19.1758 5.89894 18.7413 5.89894C18.5963 5.89894 18.4901 5.92289 18.4148 5.97254ZM14.8601 7.14444C14.3566 7.47634 14.5844 8.24164 15.1866 8.24164C15.5594 8.24164 15.772 8.02904 15.772 7.65624C15.772 7.28344 15.5594 7.07084 15.1866 7.07084C15.0417 7.07084 14.9354 7.09479 14.8601 7.14444ZM6.19379 10.6583L4.05644 11.8945L4.05534 15.7617C4.05419 20.069 4.03389 19.7417 4.31319 19.9258C4.48799 20.0411 16.5102 20.0411 16.685 19.9258C16.9664 19.7403 16.9439 20.1952 16.9439 14.707C16.9439 9.95104 16.9414 9.78139 16.8703 9.67349C16.6914 9.40214 16.8093 9.41459 14.4162 9.41429L12.259 9.41404L12.2482 12.7051C12.2361 16.3689 12.2522 16.1587 11.9718 16.3297C11.656 16.5222 11.4666 16.4457 10.919 15.9046L10.4991 15.4896L10.0792 15.9046C9.53159 16.4457 9.34214 16.5222 9.02639 16.3297C8.74599 16.1587 8.76204 16.3689 8.74999 12.7051L8.73914 9.41404L8.53514 9.41809C8.34124 9.42194 8.22504 9.48349 6.19379 10.6583ZM9.91314 11.9412V14.4684L10.0401 14.3483C10.2134 14.1842 10.3098 14.1406 10.4991 14.1406C10.6883 14.1406 10.7848 14.1842 10.9581 14.3483L11.085 14.4684V11.9412V9.41404H10.4991H9.91314V11.9412Z"
                  fill="#FFCD00"
                />
              </g>
              <defs>
                <clipPath id="clip0_58_480">
                  <rect
                    width="20"
                    height="20"
                    fill="white"
                    transform="translate(0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
            {product?.type === "reserve" ? "ซื้อสิทธิ์จองเลขท้าย" : "ซื้อคูปอง"}
          </Button>

          <Typo.Body1 textAlign="center" margin="0 0 12px 0" color="dangerRed">
            คูปองหมดอายุ{" "}
            {new Date(product?.expireAt).toLocaleDateString("th-TH", {
              year: "numeric",
              month: "numeric",
              day: "numeric",
              hour: "numeric",
              minute: "numeric",
            })}
          </Typo.Body1>
        </Flex>
      </ContentContainer>
    </CouponDetailContainer>
  );
};

const PaymentContainer = ({
  product,
  couponId,
  isShowForm,
  setShowForm,
  previewImage,
  setPreviewImage,
  setSlip,
  slip,
  uploadRef,
  handleSubmit,
  go,
  handleRedeemPointSubmit,
}) => {
  return (
    <>
      <Typo.H6 margin="35px 0 0 0" color="navy" textAlign="center">
        คูปอง
      </Typo.H6>

      <ContentContainer
        padding="32px 80px"
        paddingMobile="24px 20px"
        minHeight="0"
      >
        <Typo.H7 color="textBlack">รายการสินค้า</Typo.H7>
        <Flex margin="24px 0" align="center" gap="8px">
          <img src="/images/logo_single.png" alt="logo_single" width="40px" />
          <Typo.Body1 color="textBlack">หงษ์ทอง ลอตเตอรี่ออนไลน์</Typo.Body1>
        </Flex>
        <Flex
          padding="14px 16px"
          radius="12px"
          border={`1px solid ${themes.colors.gray2}`}
          justify="space-between"
          align="center"
          wrap="wrap"
        >
          <Flex>
            <Typo.Body3 color="textBlack"> {product?.name || "-"}</Typo.Body3>
          </Flex>

          <Typo.Body3 lineHeight="15px" margin="0 10px 0 0" color={"textBlack"}>
            {product?.price.toLocaleString() || 0} บาท
          </Typo.Body3>
        </Flex>
      </ContentContainer>

      <ContentContainer
        padding="32px 80px"
        paddingMobile="24px 20px"
        minHeight="0"
      >
        <Typo.H7 color="textBlack">สรุปรายการทั้งหมด</Typo.H7>
        <Typo.Body2 color="navy" margin="15px 0 0 0">
          ค่าสินค้า
        </Typo.Body2>
        <Flex align="center" justify="space-between">
          <Flex align="center" wrap="wrap">
            <Typo.Body1 color="textBlack"> {product?.name || "-"}</Typo.Body1>
            <Typo.Body1 color="gray4">
              : รหัสสินค้า {couponId.slice(-5).toUpperCase()}
            </Typo.Body1>
          </Flex>
          <Typo.Body3 lineHeight="15px" margin="0 10px 0 0" color="textBlack">
            {product?.price?.toLocaleString() || 0} บาท
          </Typo.Body3>
        </Flex>

        <Line border={`2px solid ${themes.colors.gray2}`} />
        <Flex align="center" justify="space-between">
          <Typo.Body1 color="textBlack">จำนวนเงินที่ต้องชำระ</Typo.Body1>

          <Typo.H5 lineHeight="15px" margin="0 10px 0 0" color="red">
            {product?.price?.toLocaleString() || 0} บาท
          </Typo.H5>
        </Flex>
      </ContentContainer>
      <Collapse isOpen={isShowForm}>
        <ContentContainer
          minHeight="10px"
          padding="32px 80px"
          paddingMobile="24px 20px"
        >
          <Flex align="center">
            <Typo.Body1 width="100px" color="gray5">
              ธนาคาร
            </Typo.Body1>
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_533_98539)">
                <rect width="32" height="32" rx="4" fill="#00A850" />
                <circle cx="16.0031" cy="15.9992" r="10.8" fill="white" />
                <path
                  d="M21.6656 21.8121C21.1594 21.5496 20.6156 21.2871 19.8094 21.2871C19.0969 21.2871 18.5156 21.5496 17.9719 21.8121C17.3906 22.0746 16.7906 22.3559 15.9844 22.3559C15.2719 22.3559 14.7469 22.1121 14.1844 21.8496C13.6031 21.5871 13.0031 21.3059 12.1781 21.3059C11.4656 21.3059 10.8844 21.5684 10.3219 21.8121C9.74063 22.0746 9.12188 22.3559 8.33438 22.3559C8.29688 22.3559 8.24063 22.3559 8.20312 22.3559C8.27813 22.4496 8.37188 22.5621 8.44688 22.6559C9.25313 22.6371 9.85313 22.3559 10.4344 22.0934C10.9969 21.8496 11.5031 21.6059 12.1594 21.6059C12.9094 21.6059 13.4531 21.8684 14.0344 22.1309C14.5969 22.3934 15.1969 22.6746 15.9656 22.6746C16.8281 22.6746 17.4656 22.3746 18.0844 22.0934C18.6281 21.8496 19.1531 21.6059 19.8094 21.6059C20.5406 21.6059 21.0281 21.8496 21.5344 22.1121C22.0781 22.3934 22.6594 22.6746 23.5969 22.6746C23.6906 22.5809 23.7656 22.4684 23.8594 22.3559C23.7844 22.3559 23.6906 22.3746 23.6156 22.3746C22.7344 22.3371 22.1906 22.0746 21.6656 21.8121Z"
                  fill="#827974"
                />
                <path
                  d="M19.8063 21.8496C19.0938 21.8496 18.5125 22.1121 17.9688 22.3746C17.3875 22.6371 16.7875 22.9184 15.9813 22.9184C15.2688 22.9184 14.7438 22.6746 14.1813 22.4121C13.6 22.1496 13 21.8684 12.175 21.8684C11.4625 21.8684 10.8813 22.1309 10.3188 22.3746C9.83125 22.5996 9.30625 22.8246 8.6875 22.8996C8.78125 22.9934 8.85625 23.0871 8.95 23.1621C9.53125 23.0684 10 22.8621 10.45 22.6559C11.0125 22.4121 11.5187 22.1684 12.175 22.1684C12.925 22.1684 13.4688 22.4309 14.05 22.6934C14.6125 22.9559 15.2125 23.2371 15.9813 23.2371C16.8438 23.2371 17.4812 22.9371 18.1 22.6559C18.6438 22.3934 19.1688 22.1684 19.825 22.1684C20.5563 22.1684 21.0438 22.4121 21.55 22.6746C22 22.8996 22.45 23.1246 23.1063 23.2184C23.2 23.1246 23.2938 23.0309 23.3688 22.9371C22.6375 22.8996 22.15 22.6371 21.6813 22.4121C21.1375 22.1121 20.6125 21.8496 19.8063 21.8496Z"
                  fill="#827974"
                />
                <path
                  d="M19.8141 22.4121C19.1016 22.4121 18.5203 22.6746 17.9766 22.9371C17.3953 23.1996 16.7953 23.4809 15.9891 23.4809C15.2766 23.4809 14.7516 23.2371 14.1891 22.9746C13.6078 22.7121 13.0078 22.4309 12.1828 22.4309C11.4703 22.4309 10.8891 22.6934 10.3266 22.9371C9.97031 23.1059 9.59531 23.2746 9.16406 23.3684C9.25781 23.4434 9.33281 23.5371 9.42656 23.6121C9.78281 23.4996 10.1203 23.3496 10.4391 23.2184C11.0016 22.9746 11.5078 22.7309 12.1641 22.7309C12.9141 22.7309 13.4578 22.9934 14.0391 23.2559C14.6016 23.5184 15.2016 23.7996 15.9703 23.7996C16.8328 23.7996 17.4703 23.4996 18.0891 23.2184C18.6328 22.9746 19.1578 22.7309 19.8141 22.7309C20.5453 22.7309 21.0328 22.9746 21.5391 23.2184C21.8578 23.3871 22.1766 23.5371 22.5891 23.6496C22.6828 23.5746 22.7766 23.4809 22.8703 23.4059C22.4016 23.3121 22.0453 23.1246 21.6891 22.9371C21.1453 22.6934 20.6203 22.4121 19.8141 22.4121Z"
                  fill="#827974"
                />
                <path
                  d="M19.8109 22.9941C19.0984 22.9941 18.5172 23.2566 17.9734 23.5191C17.3922 23.7816 16.7922 24.0629 15.9859 24.0629C15.2734 24.0629 14.7484 23.8191 14.1859 23.5566C13.6047 23.2941 13.0047 23.0129 12.1797 23.0129C11.4672 23.0129 10.8859 23.2754 10.3234 23.5191C10.0984 23.6129 9.89219 23.7254 9.64844 23.8004C9.74219 23.8754 9.83594 23.9504 9.92969 24.0254C10.1172 23.9504 10.2859 23.8754 10.4547 23.8004C11.0172 23.5566 11.5234 23.3129 12.1797 23.3129C12.9297 23.3129 13.4734 23.5754 14.0547 23.8379C14.6172 24.1004 15.2172 24.3816 15.9859 24.3816C16.8484 24.3816 17.4859 24.0816 18.1047 23.8004C18.6484 23.5379 19.1734 23.3129 19.8297 23.3129C20.5609 23.3129 21.0484 23.5566 21.5547 23.8191C21.7234 23.9129 21.9109 24.0066 22.0984 24.0816C22.1922 24.0066 22.2859 23.9316 22.3797 23.8566C22.1359 23.7629 21.9109 23.6504 21.6859 23.5379C21.1422 23.2566 20.6172 22.9941 19.8109 22.9941Z"
                  fill="#827974"
                />
                <path
                  d="M19.8078 23.5566C19.0953 23.5566 18.5141 23.8191 17.9703 24.0816C17.3891 24.3441 16.7891 24.6254 15.9828 24.6254C15.2703 24.6254 14.7453 24.3816 14.1828 24.1191C13.6016 23.8379 13.0016 23.5754 12.1766 23.5754C11.4641 23.5754 10.8828 23.8379 10.3203 24.0816C10.2641 24.1191 10.1891 24.1379 10.1328 24.1754C10.2266 24.2504 10.3203 24.3066 10.4141 24.3816C10.4328 24.3816 10.4328 24.3816 10.4516 24.3629C11.0141 24.1191 11.5203 23.8754 12.1766 23.8754C12.9266 23.8754 13.4703 24.1379 14.0516 24.4004C14.6141 24.6629 15.2141 24.9441 15.9828 24.9441C16.8453 24.9441 17.4828 24.6441 18.1016 24.3629C18.6453 24.1004 19.1703 23.8754 19.8266 23.8754C20.5578 23.8754 21.0453 24.1191 21.5516 24.3816C21.5703 24.4004 21.5891 24.4004 21.6266 24.4191C21.7203 24.3629 21.8141 24.2879 21.9078 24.2316C21.8328 24.1941 21.7578 24.1566 21.7016 24.1191C21.1391 23.8379 20.6141 23.5566 19.8078 23.5566Z"
                  fill="#827974"
                />
                <path
                  d="M17.9328 24.643C17.3516 24.9055 16.7516 25.1867 15.9453 25.1867C15.2328 25.1867 14.7078 24.943 14.1453 24.6805C13.5641 24.418 12.9641 24.1367 12.1391 24.1367C11.5578 24.1367 11.0703 24.3055 10.6016 24.5117C10.7141 24.5867 10.8078 24.643 10.9203 24.6992C11.2953 24.5492 11.6891 24.4367 12.1391 24.4367C12.8891 24.4367 13.4328 24.6992 14.0141 24.9617C14.5766 25.2242 15.1766 25.5055 15.9453 25.5055C16.8078 25.5055 17.4453 25.2055 18.0641 24.9242C18.6078 24.6805 19.1328 24.4367 19.7891 24.4367C20.3141 24.4367 20.7078 24.5492 21.0641 24.718C21.1766 24.6617 21.2703 24.5867 21.3641 24.5305C20.9328 24.3242 20.4453 24.1367 19.7891 24.1367C19.0953 24.1367 18.4953 24.3992 17.9328 24.643Z"
                  fill="#827974"
                />
                <path
                  d="M16 4C9.38125 4 4 9.38125 4 16C4 22.6187 9.38125 28 16 28C22.6187 28 28 22.6187 28 16C28 9.38125 22.6187 4 16 4ZM16 26.0875C10.4312 26.0875 5.9125 21.5688 5.9125 16C5.9125 10.4312 10.4312 5.9125 16 5.9125C21.5688 5.9125 26.0875 10.4312 26.0875 16C26.0875 21.5688 21.5688 26.0875 16 26.0875Z"
                  fill="#F23128"
                />
                <path
                  d="M21.6078 13.0371C21.5328 13.4121 21.1578 13.8059 20.9516 13.9746C20.4828 14.3496 17.3703 16.2434 17.0141 16.6746C16.6578 17.1059 16.6016 17.7621 16.6016 18.2496V21.9059H17.0891C17.0891 21.5871 17.0891 21.0434 17.0891 20.9684C17.0891 20.6496 17.2766 20.1434 17.6516 19.7496C18.2891 19.0746 19.7703 18.2496 20.7641 17.5371C21.5703 16.9371 21.6266 16.1309 21.6266 15.4371C21.6266 14.8559 21.6266 13.2434 21.6266 12.9434L21.6078 13.0371Z"
                  fill="#00A850"
                />
                <path
                  d="M16.6172 16.45C16.9547 16.0188 20.1797 14.0688 20.6297 13.6938C21.0797 13.3188 21.6234 12.7563 21.6234 12.025C21.6234 11.4063 21.6234 8.36875 21.6234 7.9375C21.6234 8.51875 21.3047 8.95 20.8922 9.49375C20.4234 10.1125 18.2672 11.275 17.1984 12.025C16.1297 12.775 15.7734 13.5063 15.7734 14.425C15.7734 15.1938 15.7734 20.2563 15.7734 21.8875H16.2422C16.2422 20.8188 16.2422 18.3625 16.2422 17.9875C16.2234 17.5 16.2609 16.8813 16.6172 16.45Z"
                  fill="#00A850"
                />
                <path
                  d="M14.1828 12.2121C13.2078 11.4621 11.2203 9.86836 10.9766 9.54961C10.7328 9.23086 10.2266 8.66836 10.2266 7.97461C10.2266 8.48086 10.2266 11.3121 10.2266 11.7809C10.2266 12.3246 10.4891 13.2996 11.4266 13.9934C12.3641 14.6871 13.6953 15.6809 14.1078 16.0934C14.5016 16.4871 14.8766 17.2184 14.8766 18.2496C14.8766 18.9996 14.8766 21.0059 14.8766 21.9246H15.3453C15.3453 20.3496 15.3453 15.5871 15.3453 14.6309C15.3828 13.4309 15.1578 12.9621 14.1828 12.2121Z"
                  fill="#00A850"
                />
              </g>
              <defs>
                <clipPath id="clip0_533_98539">
                  <rect width="32" height="32" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <Typo.Body1 margin="0 0 0 10px" color="textBlack">
              ธนาคารกสิกรไทย
            </Typo.Body1>
          </Flex>
          <Flex align="center" margin="20px 0">
            <Typo.Body1 width="100px" color="gray5">
              ชื่อบัญชี
            </Typo.Body1>

            <Typo.Body1 color="textBlack">บจก. หงษ์ทอง ออนไลน์</Typo.Body1>
          </Flex>
          <Flex align="center" justify="space-between">
            <Flex>
              <Typo.Body1 width="100px" color="gray5">
                เลขที่บัญชี
              </Typo.Body1>
              <Typo.Body1 id="btnCopyLink" color="textBlack">
                105-324-6105
              </Typo.Body1>
            </Flex>

            <Button
              background="yellow"
              hoverBg="transparent"
              hoverColor="yellow"
              hoverBorder="yellow"
              color="navy"
              onClick={() => {
                const copyText =
                  document.getElementById("btnCopyLink").innerHTML;
                window.navigator.clipboard.writeText(copyText);
                // toast("คัดลอกเลขบัญชีเเล้ว", {
                //   icon: "success",
                //   autoClose: 1000,
                // });
              }}
            >
              คัดลอก
            </Button>
          </Flex>
          <Line />
          <Flex align="center" justify="space-between">
            <Typo.Body1 id="btnCopyLink" color="textBlack">
              ยอดที่ต้องชำระ
            </Typo.Body1>

            <Typo.H5 color="red">
              {Number(product?.price).toLocaleString()} บาท
            </Typo.H5>
          </Flex>
          {previewImage && (
            <>
              <Line />
              <Flex align="center" justify="space-between">
                <Typo.Body1 id="btnCopyLink" color="textBlack">
                  หลักฐานการโอนเงิน
                </Typo.Body1>
                <Flex gap="15px">
                  <Button
                    background="navy"
                    hoverBg="transparent"
                    hoverBorder="navy"
                    hoverColor="navy"
                    onClick={() => window.open(previewImage)}
                  >
                    ดูสลิป
                  </Button>
                  <Button
                    background="red"
                    hoverBg="transparent"
                    hoverBorder="red"
                    hoverColor="red"
                    onClick={() => {
                      setPreviewImage(undefined);
                      setSlip(false);
                    }}
                  >
                    ลบ
                  </Button>
                </Flex>
              </Flex>
            </>
          )}
        </ContentContainer>
        {/* {!previewImage && ( */}
        {!slip && (
          <>
            <Button
              margin="24px 0 12px 0"
              height="55px"
              width="100%"
              hoverColor="navy"
              background="gradient2"
              hoverBg="transparent"
              hoverBorder="navy"
              gap="10px"
              onClick={() => uploadRef.current.click()}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M10.147 0.882191C9.965 0.960341 4.86025 6.05364 4.7475 6.26964C4.4763 6.78904 4.83795 7.45039 5.41615 7.49219C5.85085 7.52364 5.7787 7.58189 7.7935 5.57244L9.63925 3.73169V9.00939C9.63925 13.6601 9.64635 14.3074 9.69935 14.4575C9.9632 15.2053 11.0856 15.1773 11.3134 14.4172C11.3458 14.3089 11.358 12.8345 11.358 9.00004V3.73169L13.2037 5.57244C15.2185 7.58189 15.1463 7.52364 15.581 7.49219C16.1598 7.45034 16.5193 6.78919 16.2476 6.26644C16.1304 6.04094 11.0284 0.957941 10.8416 0.880591C10.6587 0.804791 10.3254 0.805541 10.147 0.882191ZM1.8072 10.8944C1.61575 10.9831 1.46005 11.1441 1.3796 11.3367C1.29215 11.5461 1.2893 15.3677 1.37625 15.8641C1.6684 17.5322 2.9665 18.8303 4.6346 19.1224C5.1241 19.2082 15.8731 19.2082 16.3626 19.1224C18.0307 18.8303 19.3288 17.5322 19.6209 15.8641C19.7079 15.3677 19.705 11.5461 19.6176 11.3367C19.3649 10.7318 18.5035 10.6408 18.1299 11.1796L18.0181 11.3409L17.9944 13.4341C17.9689 15.68 17.9692 15.6765 17.7544 16.1392C17.4628 16.7674 16.8669 17.2494 16.1626 17.4265C15.8434 17.5068 5.15375 17.5068 4.83455 17.4265C4.1303 17.2494 3.5344 16.7674 3.24275 16.1392C3.028 15.6765 3.0283 15.68 3.0028 13.4341L2.97905 11.3409L2.86725 11.1796C2.64565 10.86 2.16235 10.73 1.8072 10.8944Z"
                  fill="#FFCD00"
                />
              </svg>
              อัปโหลดสลิป
            </Button>
            <input
              ref={uploadRef}
              style={{ display: "none" }}
              type="file"
              onChange={async (e) => {
                const file = e.target.files[0];
                const base64 = await resizeImage(file);
                if (base64) {
                  const previewUrl = URL.createObjectURL(file);
                  setPreviewImage(previewUrl);
                  setSlip(base64);
                } else {
                  alert("อัพโหลด ได้เฉพาะ ไฟล์รูปภาพ นามสกุล jpg หรือ png");
                }
              }}
            />

            <Typo.Body5 color="gray5" textAlign="center">
              รองรับนามสกุลไฟล์ .jpg, .png, .jpeg เท่านั้น
            </Typo.Body5>
          </>
        )}
        {/* )} */}
      </Collapse>

      {isShowForm ? (
        <Button
          disabled={!slip}
          width="100%"
          hoverBg="transparent"
          hoverBorder="navy"
          hoverColor="navy"
          background="gradient2"
          onClick={() => handleSubmit()}
          margin="24px 0"
        >
          ยืนยันคำสั่งซื้อ <IoIosArrowForward />
        </Button>
      ) : (
        <Grid margin="24px 0" columns={2}>
          <Button
            color="navy"
            onClick={() => go("/coupon")}
            hoverBg="transparent"
            background="transparent"
          >
            <IoIosArrowBack
              style={{
                color: themes.colors.navy,
                marginRight: "7px",
              }}
            />
            ย้อนกลับ
          </Button>
          {product?.price > 0 ? (
            <Button
              width="100%"
              hoverBg="transparent"
              hoverBorder="navy"
              hoverColor="navy"
              background="gradient2"
              onClick={() => setShowForm(true)}
            >
              ดำเนินการต่อ <IoIosArrowForward style={{}} />
            </Button>
          ) : (
            <Button
              width="100%"
              hoverBg="transparent"
              hoverBorder="navy"
              hoverColor="navy"
              background="gradient2"
              onClick={() => handleRedeemPointSubmit()}
            >
              ยืนยันคำสั่งซื้อ
            </Button>
          )}
        </Grid>
      )}
    </>
  );
};

const CouponModal = ({
  showModal,
  setShowModal,
  isFailed,
  price,
  handleRedeemPointSubmit,
}) => {
  const toggle = () => {
    setShowModal(!showModal);
  };
  return (
    <Modal centered isOpen={showModal} toggle={toggle}>
      <ContentContainer padding="24px 24px">
        <Flex direction="column" align="center" gap="25px">
          {isFailed ? (
            <>
              <svg
                width="61"
                height="60"
                viewBox="0 0 61 60"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M30.5 50C41.5457 50 50.5 41.0457 50.5 30C50.5 18.9543 41.5457 10 30.5 10C19.4543 10 10.5 18.9543 10.5 30C10.5 41.0457 19.4543 50 30.5 50ZM30.5 55C44.3071 55 55.5 43.8071 55.5 30C55.5 16.1929 44.3071 5 30.5 5C16.6929 5 5.5 16.1929 5.5 30C5.5 43.8071 16.6929 55 30.5 55Z"
                  fill="#D60B0B"
                />
                <path
                  d="M28 30C28 28.6193 29.1193 27.5 30.5 27.5C31.8807 27.5 33 28.6193 33 30V40C33 41.3807 31.8807 42.5 30.5 42.5C29.1193 42.5 28 41.3807 28 40V30Z"
                  fill="#D60B0B"
                />
                <path
                  d="M33 20C33 21.3807 31.8807 22.5 30.5 22.5C29.1193 22.5 28 21.3807 28 20C28 18.6193 29.1193 17.5 30.5 17.5C31.8807 17.5 33 18.6193 33 20Z"
                  fill="#D60B0B"
                />
              </svg>
              <Typo.H5 color="navy">ไม่สามารถแลกคูปองได้</Typo.H5>

              <Typo.Body1 textAlign="center" color="textBlack">
                คะแนนสะสมของคุณไม่เพียงพอต่อการแลกคูปองนี้
              </Typo.Body1>
              <Button
                width="100%"
                hoverColor="navy"
                background="gradient2"
                hoverBg="transparent"
                hoverBorder="navy"
                onClick={() => toggle()}
              >
                ปิด
              </Button>
            </>
          ) : (
            <>
              <svg
                width="61"
                height="60"
                viewBox="0 0 61 60"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_836_54886)">
                  <path
                    d="M15.95 0H30.923C34.427 0.1875 37.7105 1.61602 40.1094 4.15312C42.632 6.81953 43.8848 10.0508 43.8676 13.8469C43.8676 13.8961 43.8848 13.9031 43.9191 13.868C44.441 13.3367 44.9609 12.8164 45.4789 12.307C46.4574 11.3449 47.9656 11.6238 48.4473 12.9152C48.677 13.5305 48.4824 14.2758 48.0125 14.7434C46.7484 16.002 45.2453 17.5055 43.5031 19.2539C42.616 20.1445 41.5742 20.1387 40.6918 19.2469C39.1566 17.6961 37.6598 16.1984 36.2012 14.7539C34.8547 13.4191 36.2047 11.1961 38.0223 11.8477C38.3277 11.9578 38.6883 12.232 39.1039 12.6703C39.5008 13.0898 39.8992 13.4891 40.2992 13.868C40.3025 13.8712 40.3066 13.8734 40.3111 13.8742C40.3157 13.8751 40.3203 13.8747 40.3246 13.8729C40.3288 13.8712 40.3324 13.8682 40.335 13.8644C40.3376 13.8606 40.339 13.8561 40.3391 13.8516C40.4832 8.79258 36.984 4.4918 31.9859 3.64922C31.4531 3.55938 30.675 3.51445 29.6516 3.51445C28.5281 3.51445 27.4305 3.51523 26.3586 3.5168C26.2836 3.5168 26.275 3.54063 26.3328 3.58828C30.0711 6.65273 32.2039 11.2207 32.1313 16.0711C32.0199 23.4844 26.7125 29.8266 19.4645 31.323C12.3148 32.7996 5.18047 29.0977 2.05977 22.6688C1.1168 20.7281 0.596875 18.6289 0.5 16.3711V15.1957C0.9125 6.79805 7.61211 0.366797 15.95 0ZM28.6215 15.8191C28.6215 12.5567 27.3255 9.42782 25.0186 7.1209C22.7116 4.81398 19.5828 3.51797 16.3203 3.51797C13.0578 3.51797 9.92899 4.81398 7.62207 7.1209C5.31515 9.42782 4.01914 12.5567 4.01914 15.8191C4.01914 19.0816 5.31515 22.2105 7.62207 24.5174C9.92899 26.8243 13.0578 28.1203 16.3203 28.1203C19.5828 28.1203 22.7116 26.8243 25.0186 24.5174C27.3255 22.2105 28.6215 19.0816 28.6215 15.8191Z"
                    fill="#FFCD00"
                  />
                  <path
                    d="M19.6409 11.5419C19.6534 11.5653 19.6726 11.579 19.6984 11.5829C20.8023 11.7571 21.8761 11.9122 22.9198 12.0482C23.5761 12.1341 24.0198 12.2466 24.2511 12.3857C25.0456 12.8638 25.3737 13.9583 24.8675 14.7704C24.737 14.9798 24.5452 15.2048 24.2921 15.4454C23.4616 16.236 22.6202 17.0552 21.7679 17.9028C21.7559 17.9148 21.747 17.9294 21.7419 17.9453C21.7368 17.9612 21.7357 17.978 21.7386 17.9942C21.9183 19.113 22.1089 20.2204 22.3105 21.3165C22.4222 21.9196 22.4374 22.361 22.3562 22.6407C22.021 23.7962 20.78 24.2204 19.737 23.665C18.6269 23.0728 17.5113 22.4853 16.3902 21.9025C16.3703 21.892 16.3482 21.8865 16.3257 21.8865C16.3032 21.8865 16.2811 21.892 16.2612 21.9025C15.3745 22.3595 14.2652 22.9423 12.9331 23.6509C12.6081 23.8235 12.3187 23.9138 12.0648 23.9216C11.1952 23.9462 10.3644 23.3403 10.2448 22.4591C10.2097 22.2021 10.2202 21.9208 10.2765 21.6153C10.4921 20.4325 10.7003 19.2239 10.9011 17.9896C10.9058 17.956 10.8964 17.9275 10.873 17.904C10.0909 17.1243 9.28938 16.3442 8.46828 15.5638C8.01203 15.1294 7.73899 14.7907 7.64914 14.5478C7.33625 13.697 7.68078 12.6997 8.51984 12.3212C8.73781 12.2228 8.98938 12.1544 9.27453 12.1161C10.5355 11.9482 11.7456 11.7747 12.905 11.5958C12.9294 11.5918 12.9524 11.5821 12.9724 11.5674C12.9924 11.5528 13.0086 11.5336 13.0198 11.5114C13.5441 10.4364 14.1023 9.30323 14.6945 8.11183C15.0874 7.3212 15.6948 6.9673 16.5167 7.05011C17.3206 7.13097 17.7214 7.6255 18.073 8.35675C18.5597 9.36769 19.0823 10.4294 19.6409 11.5419ZM16.2929 12.8134C15.7409 13.9325 15.5288 14.815 14.0863 14.9814C13.7566 15.0196 13.437 15.0681 13.1277 15.1267C13.1215 15.128 13.1158 15.131 13.1112 15.1353C13.1066 15.1395 13.1032 15.145 13.1015 15.1509C13.0998 15.1569 13.0998 15.1632 13.1016 15.169C13.1033 15.1749 13.1066 15.1801 13.1113 15.1841C13.4558 15.495 13.7773 15.8075 14.0757 16.1216C14.4609 16.5278 14.6136 17.0149 14.5339 17.5829C14.4722 18.0204 14.3991 18.4544 14.3148 18.8849C14.3135 18.8914 14.3141 18.8983 14.3165 18.9045C14.319 18.9107 14.3232 18.9161 14.3286 18.9201C14.334 18.924 14.3404 18.9263 14.3471 18.9267C14.3538 18.9271 14.3605 18.9256 14.3663 18.9224C14.7538 18.7146 15.1495 18.5079 15.5534 18.3025C16.5495 17.7974 17.4167 18.4806 18.257 18.9095C18.3085 18.936 18.3288 18.9204 18.3179 18.8626C18.2335 18.4157 18.1585 17.9763 18.0929 17.5442C17.9241 16.4357 18.878 15.8368 19.5343 15.1618C19.5381 15.1582 19.5408 15.1536 19.542 15.1485C19.5433 15.1434 19.5432 15.1381 19.5416 15.1331C19.54 15.1281 19.5371 15.1236 19.5331 15.1202C19.5291 15.1168 19.5242 15.1146 19.5191 15.1138C19.1097 15.056 18.6905 14.995 18.2616 14.931C17.0534 14.7517 16.8226 13.7181 16.3386 12.8122C16.3363 12.8081 16.3329 12.8047 16.3288 12.8023C16.3248 12.8 16.3201 12.7988 16.3154 12.7989C16.3107 12.7991 16.3061 12.8005 16.3021 12.803C16.2982 12.8056 16.295 12.8092 16.2929 12.8134Z"
                    fill="#FFCD00"
                  />
                  <path
                    d="M60.4993 35.7749V43.2198C60.3297 44.03 59.8668 44.5304 59.1106 44.721C58.8282 44.7925 58.5164 44.762 58.2223 44.762C58.1809 44.7628 58.1602 44.7839 58.1602 44.8253C58.1532 49.0644 58.1539 53.4437 58.1625 57.9632C58.1637 59.0296 57.7067 59.7784 56.5981 59.9999H28.0571C27.3828 59.8562 26.925 59.5136 26.6836 58.9722C26.5735 58.7245 26.518 58.3902 26.5172 57.9691C26.5125 53.5128 26.5118 49.1374 26.5149 44.8429C26.5149 44.7905 26.4887 44.764 26.4364 44.7632C26.1375 44.7609 25.8364 44.7913 25.5469 44.7175C24.6434 44.4878 24.1653 43.7753 24.1676 42.8706C24.1754 40.7737 24.1743 38.5964 24.1641 36.3386C24.1625 35.8573 24.2184 35.4948 24.3317 35.2511C24.6563 34.5562 25.3055 34.2069 26.0754 34.2116C28.309 34.2249 30.4942 34.2253 32.6309 34.2128C32.6785 34.2128 32.6868 34.1948 32.6555 34.1589C31.2153 32.5347 30.791 30.2823 31.6383 28.2726C33.4301 24.0222 39.2496 23.6566 41.6004 27.6327C41.9379 28.2034 42.1383 28.8386 42.3059 29.4749C42.3301 29.5671 42.3524 29.5667 42.3727 29.4737C42.7133 27.9339 43.4739 26.7405 44.6543 25.8937C47.5278 23.8323 51.4664 24.9362 52.9465 28.0816C53.9121 30.1359 53.4996 32.4773 52.0008 34.1753C51.9981 34.1786 51.9963 34.1825 51.9956 34.1867C51.9949 34.1909 51.9954 34.1952 51.997 34.199C51.9986 34.2028 52.0013 34.206 52.0047 34.2083C52.008 34.2105 52.012 34.2117 52.016 34.2116C54.0778 34.228 56.2012 34.2265 58.3864 34.2069C58.8309 34.203 59.1907 34.262 59.4657 34.3839C60.0188 34.63 60.3633 35.0937 60.4993 35.7749ZM38.7621 29.8874C38.1446 27.7734 35.1657 27.9011 34.7555 30.0573C34.5598 31.0898 35.2137 32.1023 36.2098 32.3929C37.3395 32.7218 38.511 33.0566 39.7243 33.3972C39.7289 33.3983 39.7339 33.3982 39.7385 33.3969C39.7431 33.3956 39.7474 33.3932 39.7508 33.3897C39.7542 33.3863 39.7567 33.3821 39.758 33.3774C39.7593 33.3728 39.7594 33.3679 39.7582 33.3632C39.4129 32.1343 39.0809 30.9757 38.7621 29.8874ZM49.3172 28.9382C48.1442 27.8331 46.3266 28.3933 45.8907 29.9284C45.5672 31.0675 45.2403 32.2116 44.9098 33.3609C44.9081 33.367 44.9081 33.3735 44.9098 33.3797C44.9114 33.3859 44.9147 33.3915 44.9192 33.396C44.9237 33.4005 44.9293 33.4038 44.9355 33.4054C44.9417 33.4071 44.9482 33.407 44.9543 33.4054C45.9871 33.1015 47.0082 32.8109 48.0176 32.5335C48.484 32.4046 48.834 32.2605 49.0676 32.1011C50.1188 31.3851 50.2582 29.8241 49.3172 28.9382ZM37.0618 37.8327C37.0618 37.8066 37.0514 37.7816 37.0329 37.7631C37.0145 37.7447 36.9894 37.7343 36.9633 37.7343H27.7852C27.7591 37.7343 27.734 37.7447 27.7156 37.7631C27.6971 37.7816 27.6868 37.8066 27.6868 37.8327V41.1515C27.6868 41.1776 27.6971 41.2026 27.7156 41.2211C27.734 41.2395 27.7591 41.2499 27.7852 41.2499H36.9633C36.9894 41.2499 37.0145 41.2395 37.0329 41.2211C37.0514 41.2026 37.0618 41.1776 37.0618 41.1515V37.8327ZM44.093 37.8152C44.093 37.7937 44.0845 37.7731 44.0693 37.758C44.0542 37.7428 44.0336 37.7343 44.0121 37.7343H40.6582C40.6368 37.7343 40.6162 37.7428 40.6011 37.758C40.5859 37.7731 40.5774 37.7937 40.5774 37.8152V56.4034C40.5774 56.4249 40.5859 56.4454 40.6011 56.4606C40.6162 56.4758 40.6368 56.4843 40.6582 56.4843H44.0121C44.0336 56.4843 44.0542 56.4758 44.0693 56.4606C44.0845 56.4454 44.093 56.4249 44.093 56.4034V37.8152ZM56.9836 37.821C56.9836 37.8096 56.9814 37.7983 56.977 37.7878C56.9727 37.7773 56.9663 37.7677 56.9582 37.7597C56.9502 37.7516 56.9406 37.7453 56.9301 37.7409C56.9196 37.7365 56.9083 37.7343 56.8969 37.7343H47.6953C47.684 37.7343 47.6727 37.7365 47.6622 37.7409C47.6516 37.7453 47.6421 37.7516 47.634 37.7597C47.626 37.7677 47.6196 37.7773 47.6152 37.7878C47.6109 37.7983 47.6086 37.8096 47.6086 37.821V41.1632C47.6086 41.1862 47.6178 41.2083 47.634 41.2245C47.6503 41.2408 47.6723 41.2499 47.6953 41.2499H56.8969C56.9199 41.2499 56.942 41.2408 56.9582 41.2245C56.9745 41.2083 56.9836 41.1862 56.9836 41.1632V37.821ZM37.0618 44.8429C37.0618 44.8327 37.0598 44.8227 37.0559 44.8133C37.052 44.8039 37.0463 44.7954 37.0391 44.7882C37.0319 44.781 37.0234 44.7753 37.014 44.7714C37.0046 44.7675 36.9946 44.7655 36.9844 44.7655H30.1078C30.0977 44.7655 30.0876 44.7675 30.0782 44.7714C30.0689 44.7753 30.0603 44.781 30.0532 44.7882C30.046 44.7954 30.0403 44.8039 30.0364 44.8133C30.0325 44.8227 30.0305 44.8327 30.0305 44.8429V56.4069C30.0305 56.4275 30.0386 56.4471 30.0532 56.4616C30.0677 56.4761 30.0873 56.4843 30.1078 56.4843H36.9844C36.9946 56.4843 37.0046 56.4823 37.014 56.4784C37.0234 56.4745 37.0319 56.4688 37.0391 56.4616C37.0463 56.4545 37.052 56.4459 37.0559 56.4365C37.0598 56.4272 37.0618 56.4171 37.0618 56.4069V44.8429ZM54.6399 44.8452C54.6399 44.8241 54.6315 44.8038 54.6165 44.7889C54.6016 44.7739 54.5813 44.7655 54.5602 44.7655H47.6883C47.6672 44.7655 47.6469 44.7739 47.632 44.7889C47.617 44.8038 47.6086 44.8241 47.6086 44.8452V56.4046C47.6086 56.4257 47.617 56.446 47.632 56.461C47.6469 56.4759 47.6672 56.4843 47.6883 56.4843H54.5602C54.5813 56.4843 54.6016 56.4759 54.6165 56.461C54.6315 56.446 54.6399 56.4257 54.6399 56.4046V44.8452Z"
                    fill="#FFCD00"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_836_54886">
                    <rect
                      width="60"
                      height="60"
                      fill="white"
                      transform="translate(0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <Typo.H5 color="navy">ต้องการแลกคูปอง ?</Typo.H5>
              <Typo.Body1 textAlign="center" color="textBlack">
                คุณต้องการแลกคูปอง <br /> โดยใช้คะแนนสะสม{" "}
                <span style={{ color: themes.colors.dangerRed }}>
                  {price} คะแนน
                </span>{" "}
                ใช่หรือไม่?
              </Typo.Body1>
              <Flex gap="25px" width="100%">
                <Button
                  width="100%"
                  hoverColor="white"
                  border="dangerRed"
                  color="dangerRed"
                  background="transparent"
                  hoverBg="dangerRed"
                  hoverBorder="dangerRed"
                  onClick={() => toggle()}
                >
                  ยกเลิก
                </Button>
                <Button
                  width="100%"
                  hoverColor="navy"
                  background="gradient2"
                  hoverBg="transparent"
                  hoverBorder="navy"
                  onClick={() => handleRedeemPointSubmit()}
                >
                  ยืนยัน
                </Button>
              </Flex>
            </>
          )}
        </Flex>
      </ContentContainer>
    </Modal>
  );
};

const ImageContainer = styled.div`
  background: #f1fff5;
  border: 3px solid #1ea94c;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px 12px 0 0;
  height: 400px;
  background-position: center;
  background-repeat: no-repeat;
  /* background-size: cover; */
`;

const CouponDetailContainer = styled(ContentContainer)`
  display: flex;
  flex-direction: column;
  padding: 0;
`;
